//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.NCGroupBuilder.js";
import "../CAM/CAM.CutParameters.js";
import "../CAM/CAM.DisplayPaint.js";
import "../CAM/CAM.DisplayPath.js";
import "../CAM/CAM.PathDisplayColors.js";
import "../CAM/CAM.DisplaySilhouette.js";
import "../CAM/CAM.DisplayTool.js";
let d=[[[1,"CutParameters",0,"CAM.CutParameters",0],[1,"PaintDisplay",0,"CAM.DisplayPaint",0],[1,"PathDisplay",0,"CAM.DisplayPath",0],[1,"PathDisplayColors",0,"CAM.PathDisplayColors",0],[1,"SilhouDisplay",0,"CAM.DisplaySilhouette",0],[1,"ToolDisplay",0,"CAM.DisplayTool",0]],[[[],"GetCutMethod",{R_:{libRef:''}},0,0],[["libRef"],"SetCutMethod",{},1,0]],[]];
SPLM.CAM.MethodBuilder = class extends SPLM.CAM.NCGroupBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.MethodBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;